import React from 'react';
import DeleteObject from '../../../../common/poppers/DeleteObject';
import ModifyOccasionalSalary from './ModifyOccasionalSalary';
import OccasionalSalaryRow from './OccasionalSalaryRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

export const occasionalSalaryActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Alkalmi fizetés módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyOccasionalSalary {...props} close={close} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Alkalmi fizetés törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/occasionalsalary'} comp={<OccasionalSalaryRow {...props} />} />
    },
]